module.exports = __webpack_public_path__ + "static/media/menu-account.6a4b88fe.svg";